// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import {createApp} from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App'
import router from './router'
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {   faBell, faComments } from '@fortawesome/free-solid-svg-icons'
import i18n from './i18n';
import LanguageSelector from '@/components/Helpers/LanguageSelector';

//Vuex Store
import store from './store'

// API Call
import apiCall from '@/repository'

/** Firebase SDK */
import { initializeApp } from "firebase/app"
import { getRemoteConfig, fetchAndActivate, getValue} from 'firebase/remote-config'
import { getMessaging, getToken } from "firebase/messaging";


const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_APP_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

const firebaseApp  = initializeApp(firebaseConfig);
const remoteConfig = getRemoteConfig(firebaseApp);

remoteConfig.settings = {
  minimumFetchIntervalMillis: 360000,
};

remoteConfig.defaultConfig = ({
  'countries': [],
});

// Language
const l = localStorage.getItem('defaultLanguage');

if (!l) { localStorage.setItem('defaultLanguage', 'English'); }


const vueApp = createApp(App);

let countries = ["LB", "JO"]
fetchAndActivate(remoteConfig)
  .then(() => {
    countries = getValue(remoteConfig,'countries').asString().split(",")
    // Vue.prototype.$activeCountries = countries
    vueApp.provide("$activeCountries" , countries)
    localStorage.setItem('activeCountries', countries);
  })
  .catch(() => {
    localStorage.setItem('activeCountries', countries);
  })


let serviceWorkerRegistration;
navigator.serviceWorker.register('/static/firebase-messaging-sw.js')
  .then((registration) => {
    serviceWorkerRegistration = registration; 
  }).catch(err => {
  console.error("SW Error", err)
})

vueApp.config.globalProperties.$filters = {
  formatDate(value) {
    if (value) {
      return moment(String(value)).format('MM/DD/YYYY hh:mm')
    }
  },
  validateEmail(email) {
    let at = email.indexOf("@");
    let dot = email.lastIndexOf("\.");
    return email.length > 0 &&
      at > 0 &&
      dot > at + 1 &&
      dot < email.length - 1 &&
      email[at + 1] !== "." &&
      email.indexOf(" ") === -1 &&
      email.indexOf("..") === -1;
  }
}

vueApp.config.globalProperties.$apiCall = apiCall;
vueApp.config.globalProperties.$remoteConfig = remoteConfig;

// Notifications
vueApp.config.globalProperties.$getToken = () => {
  const firebaseMessaging = getMessaging(firebaseApp);
  return getToken(firebaseMessaging, {vapidKey: process.env.VUE_APP_FIREBASE_VAPID,serviceWorkerRegistration});
}

vueApp.component('LanguageSelector', LanguageSelector);
vueApp.component('font-awesome-icon', FontAwesomeIcon);
library.add(faBell)
library.add(faComments)
vueApp.config.productionTip = false;
vueApp.use(Vuex)
vueApp.use(VueAxios, axios)
vueApp.use(i18n);
vueApp.use(router);
vueApp.use(store);
vueApp.mount('#app');

